import React, { memo } from "react";
import { EmpreenderApps } from "../files/AppsArray";
import SuporteIcon from "../empreenderUI/ui/appsIcons/SuporteIcon";
import { ObterWhatsApps } from "../hooks/ObterWhatsApps";
import IndicadorCarregando from "./IndicadorCarregando";

interface MensagemProps {
  slugAtual: string;
}

// Busca os atendentes; o resultado é gravado no histórico e exibido pelo CartaoEncaminhamento.
const ExibirContatosWhatsApp: React.FC<MensagemProps> = ({ slugAtual }) => {
  const dadosApp = EmpreenderApps.find(
    (item) => item.slug === slugAtual || item.sluges === slugAtual
  );

  const { loading } = ObterWhatsApps({ slugAtual });

  return loading ? (
    <IndicadorCarregando
      icone={dadosApp?.icon || <SuporteIcon />}
      slugAmigavel={dadosApp?.slugamigavel}
      textoChave="preparando_atendimento"
    />
  ) : null;
};

export default memo(ExibirContatosWhatsApp);
